import React, { Component, Fragment } from 'react';
import axios from 'axios';

import NoticiaPost from '../components/NoticiaPost';
import Header from '../components/Header';

class Estrutura extends Component {
  state = {
    allNews: null,
    isLoading: false,
    error: [],
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    axios
      .get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=2&per_page=100')
      .then((response) => {
        this.setState({
          allNews: response.data,
          isLoading: false,
        });
      })
      .catch((error) =>
        this.setState({
          error: error,
          isLoading: false,
        })
      );
  }

  render() {
    const { allNews, isLoading } = this.state;

    let newsResults =
      allNews !== null && isLoading === false ? (
        allNews.map((news) => (
          <NoticiaPost
            key={news.id}
            id={news.id}
            title={
              news.title.rendered.length > 70
                ? news.title.rendered.replace(/^(.{60}[^\s]*).*/, '$1').concat(' ...')
                : news.title.rendered
            }
            date={news.date}
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    return (
      <Fragment>
        <Header title={'Notícias'} />

        <section className="noticias-content">{newsResults}</section>
      </Fragment>
    );
  }
}

export default Estrutura;
